import { render } from "./DeleteProjectModal.vue?vue&type=template&id=73526034&scoped=true"
import script from "./DeleteProjectModal.vue?vue&type=script&lang=js"
export * from "./DeleteProjectModal.vue?vue&type=script&lang=js"

import "./DeleteProjectModal.vue?vue&type=style&index=0&id=73526034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73526034"]])

export default __exports__